exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:730px){.mobile-form-responsive{display:block}.search-container .fieldset-container{margin-right:0}.fieldset-container+.fieldset-container{margin-left:0}}.bookmarks-title-inline{display:inline-flex;align-items:baseline;gap:6px;white-space:nowrap;max-width:100%}.bookmarks-filter-row{margin-bottom:12px}.bookmarks-tenders-fit #page-wrapper{min-height:0!important;height:100vh;overflow:hidden}.bookmarks-tenders-fit .wrapper-content{padding-bottom:0!important}.bookmarks-tenders-fit .wrapper.wrapper-content{overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/tenders/shared.bookmarked.component.css
// module id = 1234
// module chunks = 0